"./prjectImages";
const countrydetails1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722381/country1_cgrxwa.png";
const countrydetails2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722446/country2_pp0ji5.png";
const prankcalculator1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722445/calculator2_lmktrv.png";
const prankcalculator2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722439/calculator1_wzpxge.png";
const downsyndrome1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722469/downsyndrome1_hsfczu.png";
const downsyndrome2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722474/downsyndrome2_klf5vi.png";
const oasis1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722481/fancy1_vmkbql.png";
const oasis2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722485/fancy2_p0ngjd.png";
const movie1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722487/movie1_stkzmb.png";
const movie2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756722492/movie2_xd3upq.png";
const nottodo1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756808239/nottodo1_cxbypi.png";
const nottodo2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756808240/nottodo2_kinoyi.png";
const expenses1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756808216/expensestracker1_n31qgh.png";
const expenses2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756808216/expensestracker2_nkpqki.png";
const Ecomcms1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756884521/admin1_macmix.png";
const Ecomcms2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756884521/admin2_jzkoqj.png";
const Ecomclient1 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756884521/client1_xhazmm.png";
const Ecomclient2 =
  "https://res.cloudinary.com/dt5eiyxyc/image/upload/v1756884520/client2_z0yclu.png";

export const projectsData = [
  {
    id: 1,
    image: Ecomcms1,
    transitionImage: Ecomcms2,
    title: "PK-ECOM CMS || MERN",
    codeLink: "https://github.com/orgs/PK-ECOM-CMS/repositories",
    liveLink: "https://pk-ecom-cms.vercel.app/",
    content: "It is an admin CMS for an E-Commerce Platform I am developing.",
  },
  {
    id: 1,
    image: Ecomclient1,
    transitionImage: Ecomclient2,
    title: "PK-ECOM || MERN",
    codeLink: "https://github.com/orgs/PK-ECOM-CLIENT/repositories",
    liveLink: "https://pk-ecom.vercel.app/",
    content: "It is the client side E-Commerce application.",
  },
  {
    id: 2,
    image: expenses1,
    transitionImage: expenses2,
    title: "Expenses Tracker || MERN",
    codeLink: "https://github.com/Pradeep22222/expenses-tracker-as-monolothic",
    liveLink: "https://expensestrackerapplication.herokuapp.com/",
    content:
      "Multi-user web application that lets users keep track of their expenses.",
  },
  {
    id: 3,
    image: nottodo1,
    transitionImage: nottodo2,
    title: "Not to do list || MERN ",
    codeLink: "https://github.com/Pradeep22222/not-to-do-list-ready-to-host",
    liveLink: "https://pradeep-not-to-do.herokuapp.com/",
    content:
      "Single-user web application that lets users keep a record of their activities and categorises them.",
  },
  {
    id: 4,
    image: countrydetails1,
    transitionImage: countrydetails2,
    title: "Country Info || React ",
    codeLink: "https://github.com/Pradeep22222/Country-Details-mine",
    liveLink: "https://country-details-mine.vercel.app/",
    content:
      "The application makes an API call to the public API and  provides details on capital city, population, area and language about the country we look for.",
  },
  {
    id: 5,
    image: movie1,
    transitionImage: movie2,
    title: "Movie Album || React",
    codeLink: "https://github.com/Pradeep22222/Movie-API-on-react",
    liveLink: "https://movie-api-on-react.vercel.app/",
    content:
      "The application makes an API call to fetch information about the movie we searched for from the public API. The movie received can be categorised into different categories in the front end and two different forms of views, “grid” and “list” is applied.",
  },
  {
    id: 6,
    image: prankcalculator1,
    transitionImage: prankcalculator2,
    title: "Prank-Calculator || React",
    codeLink:
      "https://github.com/Pradeep22222/react-prank-calculator-with-prank",
    liveLink: "https://react-prank-calculator-with-prank.vercel.app/",
    content:
      "It is a calculator build on react with a little prank featured applied.",
  },
  {
    id: 7,
    image: downsyndrome1,
    transitionImage: downsyndrome2,
    title: "Down Syndrom Queensland ||  HTML, CSS(SCSS) and JS",
    codeLink: "https://github.com/Pradeep22222/Capstone-Project",
    liveLink: "https://pradeep22222.github.io/Capstone-Project/index.html",
    content: `Was developed for a real client, “Down Syndrome Queensland” as a part of a curriculum project where the main feature applied was a calendar booking system. `,
  },

  {
    id: 8,
    image: oasis1,
    transitionImage: oasis2,
    title: "Oasis Fancy Collection || HTML and CSS (SCSS)",
    codeLink: "https://github.com/Pradeep22222/Oasis-fancy-collection",
    liveLink: "https://pradeep22222.github.io/Oasis-fancy-collection/",
    content:
      "A simple E-Commerce website experience, built with just HTML and CSS (SCSS) as a part of curriculum.",
  },
];
